<template>
  <div class="flex-1 flex-grow">
    <div class="flex flex-col max-w-xl mx-auto">
      <div class="flex flex-col justify-center p-6">
        <template v-if="customer">
          <div class="mb-8 text-center">
            
            <div class="text-xs tracking-wider text-gray-500 uppercase">
              You are logged in as
            </div>

            <div class="w-full mx-auto mt-8 bg-white rounded shadow-sm">
              <avatar :username="customer.name" :size="48" color="#fff" background-color="rgb(var(--accent-color))" class="mx-auto transform -translate-y-4 shadow" :custom-style="{ 'font-weight': 'bold' }" />
            
              <div class="mb-4 font-medium">
                {{ customer.name }}
              </div>
              
              <div class="p-3 text-sm text-gray-500 border-t border-gray-50">
                Not you? <button class="text-accent hover:underline" @click="logout">Logout</button>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div>
            <button class="w-full btn btn-secondary btn-lg" @click="showLoginModal = true">Login</button>
          </div>
          <div class="flex items-center my-8">
            <div class="flex-grow h-px bg-gray-200"></div>
            <div class="px-4 text-xs leading-none text-gray-500 uppercase">OR</div>
            <div class="flex-grow h-px bg-gray-200"></div>
          </div>
        </template>
        <fieldset class="form-group">
          <label class="form-label">
            Your Name
          </label>
          <input type="text" class="form-input" v-model="form.customer_name" />
          <validations :errors="errors" field="customer_name" v-show="proceeded" />
        </fieldset>
        <fieldset class="form-group">
          <label class="form-label">
            Your Email
          </label>
          <input type="email" class="form-input" v-model="form.customer_email" />
          <validations :errors="errors" field="customer_email" v-show="proceeded" />
        </fieldset>
        <fieldset class="form-group">
          <label class="form-label">
            Your Phone Number 
          </label>
          <CellphoneInput ref="cellphoneInput" :value="form.customer_phone" @input="handlePhoneInput" @load="phoneInputLoaded" placeholder="Your Phone Number" />
          <validations :errors="errors" field="customer_phone" v-show="proceeded" />
        </fieldset>
        <fieldset class="form-group">
          <label class="form-label">
            Company Name 
            <div class="ml-1 text-xs text-gray-500">Optional</div>
          </label>
          <input type="email" class="form-input" v-model="form.customer_company" />
          <validations :errors="errors" field="customer_company" v-show="proceeded" />
        </fieldset>
        <fieldset class="form-group" v-if="!customer">
          <label for="remember" class="flex items-start leading-tight form-label">
            <input type="checkbox" id="remember" class="mr-2 text-lg form-checkbox" v-model="form.save_details"> 
            <span>
              Create an account for me with this information <br>
              <span class="font-normal text-gray-500" v-show="form.save_details">We'll send your account details to your email address after you complete this booking form.</span>
            </span>
          </label>
        </fieldset>
      </div>
    </div>

    <BookBottomBar>
      <template slot="next">
        <button class="w-full btn btn-accent" @click="next()">
          Next <fa :icon="['far', 'chevron-right']" class="ml-2 text-sm" />
        </button>
      </template>
    </BookBottomBar>

    <Modal title="Login" size="max-w-sm" :open.sync="showLoginModal">
      <customer-auth class="p-6" set-mode="login" @login-success="showLoginModal = false" />
    </Modal>

  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import Avatar from 'vue-avatar'
import BookBottomBar from './BookBottomBar'
import CellphoneInput from '@/components/CellphoneInput'
import CustomerAuth from '@/views/customer/CustomerAuth'

export default {
  name: 'BookDetails',

  components: {
    Avatar,
    BookBottomBar,
    CellphoneInput,
    CustomerAuth
  },

  computed: {
    ...mapFields('booking', ['form']),
    ...mapState('customer', ['customer']),
    
    errors () {
      let array = []
      if (!this.form.customer_name) {
        array.push({ 
          field: 'customer_name', 
          rule: 'required', 
          message: 'Your name is required' 
        })
      }
      if (!this.form.customer_email) {
        array.push({ 
          field: 'customer_email', 
          rule: 'required', 
          message: 'Your email is required' 
        })
      }
      if (!this.form.customer_phone) {
        array.push({ 
          field: 'customer_phone', 
          rule: 'required', 
          message: 'Your phone number is required' 
        })
      }
      return array
    }
  },

  data () {
    return {
      showLoginModal: false,
      proceeded: false
    }
  },

  methods: {
    ...mapActions('customer', ['logout']),

    phoneInputLoaded (data) {
      // Ensure initial country is used on load
      this.form.customer_country = data.activeCountry.iso2
    },
    
    handlePhoneInput (number, country) {
      this.form.customer_phone = number
      this.form.customer_country = country.iso2
    },

    next () {
      this.proceeded = true

      if (!this.errors.length) {
        if (this.customer && this.customer.email === this.form.customer_email) {
          this.form.save_details = false
        }

        this.$parent.next()
      } else {
        this.$nextTick(() => {
          document.querySelector('.form-error').scrollIntoView({ 
            behavior: 'smooth', block: 'start', inline: 'nearest' 
          })
        })
      }
    }
  },

  watch: {
    customer (newVal, oldVal) {
      if (newVal && newVal.id) {
        this.form.customer_name = newVal.name
        this.form.customer_email = newVal.email
        this.form.customer_phone = newVal.phone
        this.form.customer_country = newVal.country
        this.form.customer_company = newVal.company
        this.form.customer_id = newVal.id
        this.form.save_details = false
      } else {
        this.form.customer_name = ''
        this.form.customer_email = ''
        this.form.customer_phone = ''
        this.form.customer_country = ''
        this.form.customer_company = ''
        this.form.customer_id = ''
        this.form.save_details = true
      }
    }
  }
}
</script>